import api from '../api';


export function fetchInvite(token) {
    return api.get(`/users/invites/${token}`)
        .then(response => response.data);
}

export function listTeamMembers(accountId) {
    return api.get(`/users?account_id=${accountId}`)
        .then(response => response.data);
}

export function listInvites(accountId) {
    return api.get(`/users/invites?account_id=${accountId}`)
        .then(response => response.data);
}

export function invite(accountId, email) {
    return api.post(`/users/invite`, {
        'account_id': accountId,
        'email': email
    }).then(response => response.data);
}

export function changePassword(current, updated) {
    return api.post(`/settings/change-password`, {
        current: current,
        updated: updated
    }).then(response => response.data);
}

export function revokeInvite(id) {
    return api.post(`/users/revoke-invite`, {
        'id': id,
    }).then(response => response.data);
}

export function acceptInvite(token, fullname, password) {
    return api.post(`/users/invites/${token}/accept`, {
        'fullname': fullname,
        'password': password,
    }).then(response => response.data);
}

export function removeTeamMember(accountId, userId) {
    return api.post(`/users/remove`, {
        'user_id': userId,
        'account_id': accountId,
    }).then(response => response.data);
}
